/** Escape a value for use inside SCIM filter double quotes. */
export function escapeScimFilterString(value: string): string {
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

export function buildJournalEntriesFilter(args: {
    entityType: string;
    targetId?: string;
    actorId?: string;
}): string {
    const parts: string[] = [`TargetType eq "${escapeScimFilterString(args.entityType)}"`];
    if (args.targetId?.trim()) {
        parts.push(`TargetId eq "${escapeScimFilterString(args.targetId.trim())}"`);
    }
    if (args.actorId?.trim()) {
        parts.push(`Actor eq "${escapeScimFilterString(args.actorId.trim())}"`);
    }
    return parts.join(' and ');
}

function journalEntryRecorded(entry: Record<string, unknown>): string {
    const raw = entry.Recorded ?? entry.recorded;
    return raw != null ? String(raw) : '';
}

function journalEntryTargetId(entry: Record<string, unknown>): string {
    const raw = entry.TargetId ?? entry.targetId;
    return raw != null ? String(raw).trim() : '';
}

/**
 * One row per TargetId, keeping the journal entry with the latest Recorded timestamp.
 */
export function deduplicateJournalEntriesByTargetId(entries: unknown[]): unknown[] {
    const byTargetId = new Map<string, Record<string, unknown>>();

    for (const item of entries) {
        if (!item || typeof item !== 'object') continue;
        const entry = item as Record<string, unknown>;
        const targetId = journalEntryTargetId(entry);
        if (!targetId) continue;

        const existing = byTargetId.get(targetId);
        if (!existing || journalEntryRecorded(entry).localeCompare(journalEntryRecorded(existing)) > 0) {
            byTargetId.set(targetId, entry);
        }
    }

    return Array.from(byTargetId.values()).sort(
        (a, b) => journalEntryRecorded(b).localeCompare(journalEntryRecorded(a))
    );
}
